import { useState } from "react";

const fmtT = (ts) => (ts ? new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—");
const londonHM = (ts) => new Date(ts).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Europe/London" });

// Tap-to-edit inline time. Shows London time; on save gives London HH:MM (caller converts to UTC ISO).
export function InlineTime({ ts, editable, onSave, testid, placeholder }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState("");
  if (!editable) return <span>{ts ? fmtT(ts) : (placeholder || "—")}</span>;
  const begin = () => { setVal(ts ? londonHM(ts) : ""); setEditing(true); };
  const commit = () => {
    setEditing(false);
    if (!val) return;
    const cur = ts ? londonHM(ts) : "";
    if (val !== cur) onSave(val);
  };
  if (editing) return (
    <input type="time" autoFocus data-testid={testid ? `${testid}-input` : undefined}
      value={val} onChange={(e) => setVal(e.target.value)} onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); commit(); } if (e.key === "Escape") setEditing(false); }}
      className="h-6 w-[74px] rounded border border-brand/60 bg-white px-1 text-xs font-mono focus:outline-none focus:ring-1 focus:ring-brand" />
  );
  return (
    <button type="button" data-testid={testid} onClick={begin} title="Tap to edit"
      className="rounded px-1 -mx-1 border-b border-dashed border-slate-300 hover:border-brand hover:text-brand hover:bg-amber-50 transition-colors">
      {ts ? fmtT(ts) : (placeholder || "+ add")}
    </button>
  );
}
